const debounce = (func, delay) => {
	let timeout
	return function(...args) {
		clearTimeout(timeout)
		timeout = setTimeout(() => func.apply(this, args), delay)
	}
}

export default debounce
